import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    height?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomVector = ({ height = 24, props }: Props): JSX.Element => {
    const computedWidth = (height / 24) * 24;
    return (
        <SvgIcon {...props} style={{ width: computedWidth, height: height }} viewBox={`0 0 ${computedWidth} ${height}`}>
            <path
                d={
                    'M6.16667 21.5L0.333336 15.6667L6.16667 9.83333L7.82917 11.4667L4.79584 14.5H22.5V16.8333H4.79584L7.82917 19.8667L6.16667 21.5ZM17.8333 12.1667L16.1708 10.5333L19.2042 7.5H1.5V5.16667H19.2042L16.1708 2.13333L17.8333 0.5L23.6667 6.33333L17.8333 12.1667Z'
                }
            />
        </SvgIcon>
    );
};
